import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import PrivatePolicyAction from './action';
import factory from './factory';

function* getPrivatePolicy() {
    yield takeEvery(
        PrivatePolicyAction.GET_PRIVATE_POLICY,
        function* (payload) {
            try {
                const response = yield call(() =>
                    factory.getPrivatePolicy(payload?.payload),
                );
                if (response?.data) {
                    yield put({
                        type: PrivatePolicyAction.GET_PRIVATE_POLICY_SUCCESS,
                        payload: response?.data,
                    });
                }
            } catch (error) {
                yield put({
                    type: PrivatePolicyAction.GET_PRIVATE_POLICY_FAILED,
                });
            }
        },
    );
}
export default function* rootSaga() {
    yield all([fork(getPrivatePolicy)]);
}
